import { useState, useCallback } from 'react';
import { Element, CombinationResult } from '../types';
import * as apiService from '../services/apiService';

const useElementCombination = (elements: Element[], setElements: React.Dispatch<React.SetStateAction<Element[]>>) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleCombineElements = useCallback(async (element1: Element, element2: Element): Promise<CombinationResult | null> => {
    try {
      console.log(`Проверка комбинации элементов: ${element1.name} + ${element2.name}`);
      setIsLoading(true);
      
      const result = await apiService.checkCombination(element1._id, element2._id);
      
      if (result) {
        console.log(`Получен результат комбинации: ${result.newElement.name}, новый: ${result.isNew}`);
        
        const existingElement = elements.find(e => e._id === result.newElement._id);
        
        if (!existingElement) {
          console.log(`Добавляем новый элемент: ${result.newElement.name}`);
          setElements(prev => [...prev, result.newElement]);
        }
        
        return result;
      }
      return null;
    } catch (error) {
      console.error('Ошибка при комбинации элементов:', error);
      return null;
    } finally {
      setIsLoading(false);
    }
  }, [elements, setElements]);

  return { handleCombineElements, isLoading };
};

export default useElementCombination; 